import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { APPINSTALLATION_RESOURCE } from '../../constants';
import apiRoutes from '../../../../app/api/routes';

const AppInstallationService = ComposedComponent =>
  reduxFetch([
    {
      resource: APPINSTALLATION_RESOURCE,
      method: 'get',
      request: (id, installationId, t) => ({
        url: apiRoutes.appInstallationsDetail(id, installationId),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getAppInstallationFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default AppInstallationService;
